
import React, { useContext } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Auth/context/Auth";
import { MdEdit } from "react-icons/md";
import { QRCodeCanvas } from "qrcode.react";
import { RiLockPasswordFill } from "react-icons/ri";
import Cards from "../DashboardCards/Cards";
import NewPolicy from "../../Componenet/PolicyList/NewPolicy";

const Personal = () => {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const userData = auth.userData;
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {["admin", "insurance"].includes(userData?.role) && (
        <Cards />
      )}
      <Box
        sx={{
          width: "100%",
          // height:{xs:"100vh",md:"62vh"},
          background: "#F5F5F5",
          display: "flex",
          justifyContent: "center",
          px: { xs: 2, md: 4 },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "1200px", mt: 3 }}>
          {/* Header Card */}
          {/* <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3, md: 4 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            mb: 4,
            borderRadius: "16px",
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Avatar
            sx={{ width: 64, height: 64, mb: { xs: 2, sm: 0 }, mr: { sm: 2 } }}
          >
            {userData?.full_name?.charAt(0).toUpperCase() ?? "U"}
          </Avatar>

         
          <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
            <Typography variant="h6" fontWeight={600}>
            {userData?.full_name || "--"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
            Designation : {userData?.role?.charAt(0).toUpperCase() + userData?.role?.slice(1)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
            Address :  {userData?.address || "--"}
            </Typography>
          </Box>
        </Paper> */}

          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "space-between", // Makes space between left and right
              mb: 4,
              borderRadius: "16px",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            {/* Left section - Avatar and User Info */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                flex: 1,
              }}
            >
              <Avatar
                sx={{
                  width: 64,
                  height: 64,
                  mb: { xs: 2, sm: 0 },
                  mr: { sm: 2 },
                }}
              >
                {userData?.full_name?.charAt(0).toUpperCase() ?? "U"}
              </Avatar>

              <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
                <Typography variant="h6" fontWeight={600}>
                  {userData?.full_name || "--"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                 User ID :{" "}
                  {userData?.national_id}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Designation :{" "}
                  {userData?.role
                    ? userData.role.charAt(0).toUpperCase() + userData.role.slice(1)
                    : "--"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Address : {userData?.address || "--"}
                </Typography>
              </Box>
            </Box>

            {/* Right section - QR Code */}
            {/* <Box
              sx={{
                mt: { xs: 2, sm: 0 },
                ml: { sm: 2 },
                flexShrink: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <QRCodeCanvas
                value={userData?.national_id || "unknown-user"}
                size={130}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin={true}
              />
            </Box> */}

          </Paper>


          {/* Personal Info */}
          <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, borderRadius: "16px" }}>
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              mb={3}
              gap={2}
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{ color: "#03A7E5" }}
              >
                Personal Information
              </Typography>
              <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <Tooltip title="Edit Details">
                  <IconButton
                    sx={{ color: "#03A7E5" }}
                    onClick={() => navigate("/update")}
                  >
                    <MdEdit />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Change Password">
                  <IconButton
                    sx={{ color: "#03A7E5" }}
                    onClick={() => navigate("/password")}
                  >
                    <RiLockPasswordFill />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {/* First Row */}
            <Grid container spacing={{ xs: 2, sm: 12 }}>
              <Grid item xs={12} sm={6} md={4}>
                <InfoItem label="Full Name" value={userData?.full_name} />
                <InfoItem label="Date of Birth" value={userData?.dob_display} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoItem label=" National ID" value={userData?.national_id} />
                <InfoItem label="Status" value={userData?.status} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoItem label="User Role" value={userData?.role} />
                <InfoItem label="Gender" value={userData?.gender} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoItem label="Email Address" value={userData?.emailid} />
                <InfoItem label="Phone Number" value={userData?.phone_number} />
              </Grid>
            </Grid>

            {/* Second Row */}
            {/* <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6} md={4}>
              <InfoItem label="Date of Birth" value={userData?.dob_display} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InfoItem label="Status" value={userData?.status} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InfoItem label="Gender" value={userData?.gender} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InfoItem label="Phone Number" value={userData?.phone_number} />
            </Grid>
          </Grid> */}
          </Paper>
        </Box>
      </Box>
      {userData?.role === "policyholder" && (<>
        <Container maxWidth="lg">

          <NewPolicy />
        </Container>
      </>)}

    </>
  );
};

const InfoItem = ({ label, value }) => (
  <Box sx={{ textAlign: "left", mb: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: "13px", fontWeight: 400 }}
    >
      {label}
    </Typography>
    <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
      {value || "--"}
    </Typography>
  </Box>
);

export default Personal;
